module.exports = __webpack_public_path__ + "static/img/after_sale_lynx.8e6e363d.png";